import Vue from 'vue'
import Vuex from 'vuex'
import footerContent, { NAME_SPACE as footerNameSpace } from './modules/footer.store'
//import landingPageContent, { NAME_SPACE as landingPageNamespace } from './modules/landing-page.store'
import landlordOrderOrganisationModule from '@/store/modules/landlord-order/landlord-order-organisation.store'
import form, { NAME_SPACE as formNameSpace } from './form/form.store'
import accessibilityReportFormStore, { NAMESPACE as accessibilityReportFormNamespace } from './modules/accessibility-form.store'
import AddressSearch from './modules/address-search.store'
import area, { NAME_SPACE as areaNamespace } from './modules/area.store'
import authenticationStoreV0 from './modules/authentication-v0.store'
import authenticationStoreV1 from './modules/authentication-v1.store'
import authenticationStoreV6 from './modules/authentication-v6.store'
import landingPageContentNew, { NAME_SPACE as landingPageNamespace } from './modules/landing-page-new.store'
import { landlordOrderContactModule } from './modules/landlord-order/landlord-order-contact.store'
import landLordOrderPropertyModule from './modules/landlord-order/landlord-order-property.store'
import landlordOrderServicesModule from './modules/landlord-order/landlord-order-services.store'
import landLordOrderSummaryModule from './modules/landlord-order/landlord-order-summary.store'
import landlordWizardModule from './modules/landlord-order/landlord-wizard.store'
import noticeOfInterestForm, { NAMES_PACE as noticeOfInterestFormNamespace } from './modules/notice-of-interest-form.store'
import orderFlow, { NAMESPACE as orderFlowNamespace } from './modules/order-flow.store'
import orderSubmitStore, { NAMESPACE as orderSubmitNamespace } from './modules/order-submit.store'
import variable from './modules/variable.store'

import {
  getAddressSearchContent,
  getContactFormPageContent,
  getLandlordContactFormContent,
  getLandlordOrderContent,
  getLandlordPageContent,
  getNoticeOfInterestByAreaStatusContent,
  getNoticeOfInterestGenericPageContent,
  getNoticeOfInterestOperatorChangePageContentUpsell,
  getNoticeOfInterestUpsellPageContent,
  getOrderPageContent,
  getOrderSuccessContent,
  getRedirectModalContent,
  getServiceProvidersPageContent,
  getSimplePageContent,
  getStatusPageContent,
  getSupportPageContent,
  getWhereDoYouLivePageContent
} from '@/services/content.service'
import { getCaseReasons } from '@/services/landlord.service'
import { CfAnslSimplePage } from '@/types/ansl-space/types/cf-ansl-simple-page'
import { Namespace } from './Namespaces'
import { storeFactory } from './content-page.store'

const serviceProvidersContent = storeFactory(getServiceProvidersPageContent)
const whereDoYouLivePageContent = storeFactory(getWhereDoYouLivePageContent)
const contactFormPageContent = storeFactory(getContactFormPageContent)
const supportPageContent = storeFactory(getSupportPageContent)

const simplePageContent = storeFactory<CfAnslSimplePage, string>(getSimplePageContent)
const noticeOfInterestGenericPageContent = storeFactory(getNoticeOfInterestGenericPageContent)
const noticeOfInterestUpsellPageContent = storeFactory(getNoticeOfInterestUpsellPageContent)
const noticeOfInterestFwaPageContent = storeFactory(getNoticeOfInterestByAreaStatusContent)
const noticeOfInterestFwaLowbandPageContent = storeFactory(getNoticeOfInterestByAreaStatusContent)
const noticeOfInterestFwaSiteDevelopmentPageContent = storeFactory(getNoticeOfInterestByAreaStatusContent)
const noticeOfInterestRuralPageContent = storeFactory(getNoticeOfInterestByAreaStatusContent)
const noticeOfInterestNoCapex = storeFactory(getNoticeOfInterestByAreaStatusContent)
const noticeOfInterestOperatorChangeUpsellPageContent = storeFactory(getNoticeOfInterestOperatorChangePageContentUpsell)
const statusPageContent = storeFactory(getStatusPageContent)
const orderPageContent = storeFactory(getOrderPageContent)
const orderSuccessPageContent = storeFactory(getOrderSuccessContent)
const redirectModalContent = storeFactory(getRedirectModalContent)
const addressSearchContent = storeFactory(getAddressSearchContent)
const landlordPageContent = storeFactory(getLandlordPageContent)
const landlordContactFormContent = storeFactory(getLandlordContactFormContent)
const landlordOrderContent = storeFactory(getLandlordOrderContent)
const landlordContactFormCaseReasons = storeFactory(getCaseReasons)

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    [accessibilityReportFormNamespace]: accessibilityReportFormStore,
    [footerNameSpace]: footerContent,
    [landingPageNamespace]: landingPageContentNew,
    AddressSearch,
    [areaNamespace]: area,
    [noticeOfInterestFormNamespace]: noticeOfInterestForm,
    [orderFlowNamespace]: orderFlow,
    [orderSubmitNamespace]: orderSubmitStore,
    [formNameSpace]: form,
    [Namespace.ServiceProviders]: serviceProvidersContent,
    [Namespace.WhereDoYouLive]: whereDoYouLivePageContent,
    [Namespace.SimplePage]: simplePageContent,
    [Namespace.NoticeOfInterestGeneric]: noticeOfInterestGenericPageContent,
    [Namespace.NoticeOfInterestUpsell]: noticeOfInterestUpsellPageContent,
    [Namespace.NoticeOfInterestFwa]: noticeOfInterestFwaPageContent,
    [Namespace.NoticeOfInterestFwaLowband]: noticeOfInterestFwaLowbandPageContent,
    [Namespace.NoticeOfInterestFwaSiteDevelopment]: noticeOfInterestFwaSiteDevelopmentPageContent,
    [Namespace.NoticeOfInterestRural]: noticeOfInterestRuralPageContent,
    [Namespace.NoticeOfInterestNoCapex]: noticeOfInterestNoCapex,
    [Namespace.NoticeOfInterestOperatorChangeUpsell]: noticeOfInterestOperatorChangeUpsellPageContent,
    [Namespace.StatusPage]: statusPageContent,
    [Namespace.OrderPage]: orderPageContent,
    [Namespace.OrderSuccessPage]: orderSuccessPageContent,
    [Namespace.RedirectModalContent]: redirectModalContent,
    [Namespace.AddressSearchContent]: addressSearchContent,
    [Namespace.AuthenticationV0]: authenticationStoreV0,
    [Namespace.AuthenticationV1]: authenticationStoreV1,
    [Namespace.AuthenticationV6]: authenticationStoreV6,
    [Namespace.ContactFormContent]: contactFormPageContent,
    [Namespace.SupportPageContent]: supportPageContent,
    [Namespace.Variable]: variable,
    [Namespace.Landlord]: landlordPageContent,
    [Namespace.LandlordContactFormContent]: landlordContactFormContent,
    [Namespace.LandlordContactFormCaseReasons]: landlordContactFormCaseReasons,
    [Namespace.LandlordOrderContent]: landlordOrderContent,
    [Namespace.LandlordOrder]: {
      namespaced: true,
      modules: {
        [Namespace.LandlordOrderWizard]: landlordWizardModule,
        [Namespace.LandlordOrderServices]: landlordOrderServicesModule,
        [Namespace.LandlordOrderOrganisation]: landlordOrderOrganisationModule,
        [Namespace.LandlordOrderContact]: landlordOrderContactModule,
        [Namespace.LandlordOrderProperty]: landLordOrderPropertyModule,
        [Namespace.LandlordOrderSummary]: landLordOrderSummaryModule
      }
    }
  }
})
